import { Info } from "@icon-park/svg";
import { Icon, Popover } from "@justhome/react-ui";
import { FC, PropsWithChildren } from "react";
import styles from "./OptionCard.module.scss";

const OptionCardInfo: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Popover
      variant="white"
      trigger="hover"
      content={<p className="text-body-2">{children}</p>}
    >
      <span
        className={styles.info}
        onClick={(e) => e.preventDefault()}
        role="none"
      >
        <Icon icon={Info} size="28" />
      </span>
    </Popover>
  );
};

export default OptionCardInfo;
